import axios, {AxiosResponse} from 'axios'
import {IReservationFilterModel, IReservationModel} from './ReservationModel'
import {ApiResponse, PageResponse} from '../../../shared/models/ApiModels'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const RESERVATION_CREATE_URL = `${API_URL}api/v1/reservation/create`
export const RESERVATION_GET_ALL_URL = `${API_URL}api/v1/reservation/all`
export const RESERVATION_DELETE_URL = `${API_URL}api/v1/reservation/delete/`
export const RESERVATION_UPDATE_URL = `${API_URL}api/v1/reservation/update/`
export const RESERVATION_FILTER_URL = `${API_URL}api/v1/reservation/filter`
export const RESERVATION_GET_BY_ID_URL = `${API_URL}api/v1/reservation/getById/`

export function getReservationById(
  id: string
): Promise<AxiosResponse<ApiResponse<IReservationModel>>> {
  return axios.get(RESERVATION_GET_BY_ID_URL + encodeURIComponent(id))
}

export function createReservation(values: IReservationModel) {
  const payload: IReservationModel = {
    ...values,
    additionalServices: values.additionalServices
      ? values.additionalServices.filter((s) => s.isAdd)
      : null,
  }

  return axios.post(RESERVATION_CREATE_URL, payload)
}

export function loadReservations(page = 0) {
  return axios.get(RESERVATION_GET_ALL_URL, {params: {page, size: 10}})
}

export async function filterReservations(
  reservationFilter: IReservationFilterModel,
  page = 0,
  size = 5,
  sort: string = 'createdDate',
  order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<IReservationModel>>>> {
  return axios.post(RESERVATION_FILTER_URL, reservationFilter, {
    params: {page, size, sort, order},
  })
}

export function deleteReservation(ReservationId: String) {
  return axios.post(RESERVATION_DELETE_URL + ReservationId)
}

export function updateReservation(ReservationId: String, reservation: IReservationModel) {
  return axios.post(RESERVATION_UPDATE_URL + ReservationId, reservation)
}
